module.exports = __webpack_public_path__ + "static/media/close.03ca36a0.svg";